import { useState, useEffect, useCallback, useRef } from 'react';

import GoogleMapReact, { fitBounds } from 'google-map-react';
import { Marker } from '../business/drawer/Marker';

export const MapCompetitors = (props: {geogrid: any }) => {
    
    const [zoom, setZoom] = useState(10);
    const [center, setCenter] = useState<any>(null);
    
    useEffect(() => {
                           
        //setGeoGrid(data.geoGrid);
        //setLocation(data.location);
        let allPlaces = props.geogrid?.allPlacesStats;                
 
        if (allPlaces?.length > 0) {
            // Inicializa las coordenadas de los límites noroeste y sureste
            let minLat = allPlaces[0]?.lat;
            let maxLat = allPlaces[0]?.lat;
            let minLng = allPlaces[0]?.lng;
            let maxLng = allPlaces[0]?.lng;

            allPlaces.map((marker: { lat: number; lng: number; }) => {
                minLat = Math.min(minLat, marker.lat);
                maxLat = Math.max(maxLat, marker.lat);
                minLng = Math.min(minLng, marker.lng);
                maxLng = Math.max(maxLng, marker.lng);
            });

            //Obtiene los bounds para posicionar el mapa
            const newsBounds: any = {
                nw: { lat: minLat, lng: minLng },
                se: { lat: maxLat, lng: maxLng }
            };

            const size = {
                width: 500, 
                height: 500, 
            };

            const { center, zoom } = fitBounds(newsBounds, size);
            setCenter(center)
            setZoom(zoom)
        } else {
            const defaultCenter = { lat: props.geogrid?.center.latitude, lng: props.geogrid?.center.longitude }; 
            const defaultZoom = 15; 

            setCenter(defaultCenter);
            setZoom(defaultZoom);
        }
            
    }, []);              

    const [apiRef, setApiRef] = useState<any>(null);
    const rectRef = useRef<any>(null);
    
    // 1. Guardamos la API cuando cargue
    const handleApiLoaded = (map: any, maps: any) => {
        setApiRef({ map, maps });
    };
    
    // 2. Dibujamos el rectángulo cada vez que la API esté lista O cambien los puntos
    useEffect(() => {
        if (apiRef && props.geogrid?.points) {
            const { map, maps } = apiRef;
    
            // Limpiar el anterior si existe
            if (rectRef.current) rectRef.current.setMap(null);
    
            const lats = props.geogrid.points.map((p: any) => p.lat);
            const lngs = props.geogrid.points.map((p: any) => p.lng);
    
            rectRef.current = new maps.Rectangle({
                strokeColor: "white",
                strokeOpacity: 1,
                strokeWeight: 6,
                //fillColor: "LightYellow",
                fillOpacity: 0.0,
                map: map,
                bounds: {
                    north: Math.max(...lats),
                    south: Math.min(...lats),
                    east: Math.max(...lngs),
                    west: Math.min(...lngs)
                },
                zIndex: 100
            });
        }
    }, [apiRef, props.geogrid?.points]); // Se ejecuta al cargar la API y al recibir nuevos puntos

    const handleMarkerClick = (url: string) => {           
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    const handleZoomAnimationStart = useCallback((newZoom) => {
        setZoom(newZoom);        
      }, []); 

      const handleZoomAnimationEnd = useCallback((newZoom) => {
        setZoom(newZoom);        
      }, []);     

    return (
        center && <GoogleMapReact 
            bootstrapURLKeys={{ key: "AIzaSyCtmjrbwFhUPNP-LfETh_aAKaFuZJhwDm4" }}
            defaultCenter={{ lat: 0, lng: 0 }}
            center={center}
            zoom={zoom}
            onZoomAnimationStart={handleZoomAnimationStart}
            onZoomAnimationEnd={handleZoomAnimationEnd}                    
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}>
                      
            {props.geogrid?.allPlacesStats?.map((pos: any, index: any) => (
                <Marker
                    key={index}                            
                    lat={pos.lat}
                    lng={pos.lng}
                    location={pos}                            
                    zoom={zoom}
                    onClick={() => handleMarkerClick(pos.googleMapsUri)}
                />
            ))}

        </GoogleMapReact>                                       
    );
}
